import { jsx as _jsx } from "react/jsx-runtime";
import Button from "antd-button-color";
import Link from "next/link";
export const ButtonLink = (props) => {
    const { href, as, locale, ...rest } = props;
    return (_jsx(Link, { as: as, href: href, locale: locale, passHref: true, children: _jsx(Button, { role: "link", ...rest }) }));
};
//# sourceMappingURL=ButtonLink.js.map